import { StringType } from '../types';

/**
 *
 * @param string ie: I am a string
 * @returns lowercase string with no spaces ie: iamastring
 */
export const makeId = (string?: StringType) =>
    string?.toString().replace(/ /g, '').toLowerCase() ?? '';

/**
 *
 * @param label ie: I am a label
 * @returns lowercase string with no spaces ie: iamalabel-help
 */

export const makeHelperTextId = (label?: StringType) => makeId(`${label?.toString() ?? ''}-help`);
/**
 *
 * @param string[] Array of possible variant strings
 * @returns getIsSupportedVariant() function with correct variants and typesafety
 */
export function createIsSupportedVariant<T extends readonly string[]>(variants: T) {
    return (variant: string): variant is T[number] => {
        return variants.includes(variant);
    };
}
